/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Input, Modal, ModalContent, Pagination, Select, SelectItem, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import { IconSearch, IconPlus, IconEdit, IconTrash } from '@tabler/icons-react';
import toast from 'react-hot-toast';
import { Constants, getCountryFlagUrl, getUpdatedState } from '../../../../utils';
import { SettingsService } from '../../../../services';
import CountryFlag from '../../../../components/country-flag';
import ModalCreate from './modal-create';
import ModalDelete from './modal-delete';

const countries = [
  { value: '', label: 'Todos' },
  { value: Constants.COUNTRIES.VEN.toString(), label: 'Venezuela', url: getCountryFlagUrl(Constants.COUNTRIES.VEN) },
  { value: Constants.COUNTRIES.COL.toString(), label: 'Colombia', url: getCountryFlagUrl(Constants.COUNTRIES.COL) },
];

const MODAL = {
  NONE: 0,
  CREATE: 1,
  EDIT: 2,
  DELETE: 3,
};

const AdminSettingsAccounts = () => {
  const { canResetFilter, data, filterBy, goToPage, isLoading, pagination, reload, filters } = useFetchTable();
  const [modal, setModal] = useState(MODAL.NONE);
  const [item, setItem] = useState();

  const showModal = (modal, item = null) => {
    setItem(item);
    setModal(modal);
  }

  return (
    <div>
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <Modal
        size="sm"
        isOpen={[MODAL.CREATE, MODAL.EDIT].includes(modal)}
        onClose={() => showModal(MODAL.NONE)}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => (
            <ModalCreate
              item={item}
              onClose={onClose}
              onSuccess={() => {
                showModal(MODAL.NONE);
                reload();
              }}
            />
          )}
        </ModalContent>
      </Modal>

      <Modal
        size="sm"
        isOpen={modal === MODAL.DELETE}
        onClose={() => showModal(MODAL.NONE)}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => (
            <ModalDelete
              item={item}
              onClose={onClose}
              onSuccess={() => {
                showModal(MODAL.NONE);
                reload();
              }}
            />
          )}
        </ModalContent>
      </Modal>

      <Filters
        canResetFilter={canResetFilter}
        filterBy={filterBy}
        resetFilter={() => reload()}
        currentLevel={filters.level_id}
      />

      <div>
        <Table
          aria-label="Cuentas de Pagos Registradas"
          color="primary"
          topContentPlacement="inside"
          topContent={
            <div className="flex flex-row justify-between items-center gap-4">
              <h3 className="text-xl font-medium">Cuentas de Pagos Registradas</h3>
              <Button
                className="pr-2 bg-green font-medium text-white"
                endContent={<IconPlus color="white" />}
                onPress={() => showModal(MODAL.CREATE)}
              >
                Nuevo
              </Button>
            </div>
          }
        >
          <TableHeader>
            <TableColumn>País</TableColumn>
            <TableColumn>Nombre de entidad</TableColumn>
            <TableColumn>Número de cuenta</TableColumn>
            <TableColumn>Tipo de pago</TableColumn>
            <TableColumn>Beneficiario</TableColumn>
            <TableColumn>DNI/CI</TableColumn>
            <TableColumn>Teléfono</TableColumn>
            <TableColumn>Correo</TableColumn>
            <TableColumn>Estatus</TableColumn>
            <TableColumn align="end">Acción</TableColumn>
          </TableHeader>
          <TableBody items={data} emptyContent="No hay cuentas registradas">
            {(account) => (
              <TableRow key={account.id}>
                <TableCell><CountryFlag src={getCountryFlagUrl(account.payment_method?.country_id)} /></TableCell>
                <TableCell>{ account.bank?.name }</TableCell>
                <TableCell>{ account.account_number }</TableCell>
                <TableCell>{ account.payment_method?.name }</TableCell>
                <TableCell>{ account.name }</TableCell>
                <TableCell>{ account.dni }</TableCell>
                <TableCell>{ account.phone }</TableCell>
                <TableCell>{ account.email }</TableCell>
                <TableCell>{ account.status_text }</TableCell>
                <TableCell>
                  <div className="flex justify-end">
                    <Button isIconOnly variant="light" radius="full" onPress={() => showModal(MODAL.EDIT, account)}>
                      <IconEdit />
                    </Button>
                    <Button isIconOnly variant="light" radius="full" color="danger" onPress={() => showModal(MODAL.DELETE, account)}>
                      <IconTrash />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>

      <div className="flex w-full justify-center mt-4">
        <Pagination
          showControls
          variant="bordered"
          page={pagination.page}
          total={pagination.pages}
          onChange={goToPage}
        />
      </div>
    </div>
  );
}

const Filters = ({ canResetFilter, filterBy, resetFilter }) => {
  const initialFilter = {
    search: '',
    country_id: '',
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }

  return (
    <section className="mb-4">
      <div className="grid sm:flex grid-cols-1 lg:flex-row items-end gap-4">
        <Select
          label="País"
          labelPlacement="outside"
          placeholder="Selecciona"
          variant="bordered"
          radius="sm"
          classNames={{
            base: 'w-full sm:max-w-[15rem]',
            trigger: 'border-1',
          }}
          disallowEmptySelection={true}
          selectedKeys={[form.country_id]}
          onSelectionChange={v => onChange(v.currentKey, 'country_id')}
          startContent={<CountryFlag src={getCountryFlagUrl(+form.country_id)} />}
        >
          {countries.map((item) => (
            <SelectItem
              key={item.value}
              value={item.value}
              startContent={<CountryFlag src={item.url} />}
              classNames={{ title: 'min-w-48' }}
            >
              {item.label}
            </SelectItem>
          ))}
        </Select>
        <Input
          classNames={{
            base: 'w-full sm:max-w-[15rem]',
            inputWrapper: 'border-1 h-10',
          }}
          label="Nombre o número de cuenta"
          labelPlacement="outside"
          placeholder="Buscar"
          startContent={<IconSearch />}
          variant="bordered"
          radius="sm"
          value={form.search}
          onValueChange={v => onChange(v, 'search')}
        />

        {canResetFilter && (
          <Button
            variant="light"
            className="text-primaryDark"
            onPress={() => {
              setForm(initialFilter);
              resetFilter();
            }}
          >
            Limpiar filtros
          </Button>
        )}
      </div>
    </section>
  )
}

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    level_id: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);

  const debounceTime = 500;
  const debounce = useRef();

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const response = await SettingsService.admin.getPaymentMethodsInfo(filters)
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const canResetFilter = () => {
    const { page, perPage, ...initial } = initialFilters;
    const { page: _, perPage: __, ...current } = filters;
    delete initial.level_id;
    delete current.level_id;
    const initFilter = JSON.stringify(initial);
    const currFilter = JSON.stringify(current);
    return initFilter !== currFilter;
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    else fetchData();
  }

  const goToPage = (page) => {
    const pagination = getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const filterBy = (value, target) => {
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setCanFetch(true);
      setFilters({ ...filters, page: 1, [target]: value });
    }, debounceTime);
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  return {
    canResetFilter: canResetFilter(),
    changePerPage,
    data,
    filters,
    filterBy,
    goToPage,
    isLoading: !canFetch,
    pagination,
    reload,
  }
}

export default AdminSettingsAccounts;
